class DeliverectController extends AbstractIntegrationController
	@register()
	@inject '$filter',
		'configuration'
		'configurationOptions'
		'Shops'
		'IntegrationRepository'

	integrationId: 'deliverect'

	initialize: ->
		@shops = _.indexBy @Shops.data, 'id'

		@validateCallbacks(false) if @updating

	afterDisconnect: ->
		@configuration = {}

	save: ->
		super(@configuration).then =>
			@updateConfigurationOptions()
			@configuration.active = true

	afterDisconnect: ->
		@configuration = {
			active: false
		}

	validateCallbacks: (reload = true) ->
		if not reload
			@validateConfigurationOptions()

			return

		@updateConfigurationOptions()

	updateConfigurationOptions: ->
		@IntegrationRepository
			.getConfigurationOptions @integrationId
			.then (response) =>
				@configurationOptions = response.data

				@validateConfigurationOptions()
			.catch (response) =>
				@handleErrors response, @headerText

	validateConfigurationOptions: ->
		return if _.isEmpty @configurationOptions.locations

		for location in @configurationOptions.locations
			@removeErrorMessage "#{location.name} - locationId"

			if not @shops[location.posSettings.generic.locationId]?
				@addErrorMessage(
					"#{location.name} - locationId",
					@$filter('translate')('wbo.integration.deliverect.locationId.error')
				)

			for own key, callbackUrl of location.posSettings.wbo
				errorKey = "#{location.name} - #{key}"

				@removeErrorMessage errorKey

				if location.posSettings.generic[key] != callbackUrl
					@addErrorMessage(
						errorKey,
						@$filter('translate')('wbo.integration.deliverect.callbackUrl.error')
					)
